// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorItem_container__1EL09","item":"ErrorItem_item__2Zg1O"};